import { useLocation } from 'react-router-dom'

import { useSettings } from '@queries/settings'

const useDistribusionBranding = (placement: 'header' | 'footer') => {
  const { pathname } = useLocation()
  const [{ distribusionBranding }] = useSettings()
  const strippedPath = pathname.replace(/^\//, '')
  const isDisplayed = distribusionBranding.displayOn === placement || distribusionBranding.displayOn === 'everywhere'

  return (
    distribusionBranding.enabled &&
    distribusionBranding.pages.some(page => strippedPath.startsWith(page)) &&
    isDisplayed
  )
}

export default useDistribusionBranding
